import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { actionCreateApiGateWayFactory } from '../../actions/actionCreator';

import { ACTION_KEY as API_GATEWAY_KEYS, ACTION_ATTR as API_GATEWAY_ATTRS } from '../../constants/apiGateWayConstant';

import EditReport from '../../components/Reports/Edit';

function mapStateToProps(state) {
  return {
    editingReport: state.editingReport.editingReport,
  };
}

const mapDispatchToProps = dispatch => ({
  actions: {
    /* eslint max-len : 0 */
    getEditingReport: bindActionCreators(actionCreateApiGateWayFactory(API_GATEWAY_KEYS.GET_EDITING_REPORT, API_GATEWAY_ATTRS.PAYLOAD), dispatch),
    updateReport: bindActionCreators(actionCreateApiGateWayFactory(API_GATEWAY_KEYS.UPDATE_REPORT, API_GATEWAY_ATTRS.PAYLOAD), dispatch),
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(EditReport);



// WEBPACK FOOTER //
// ./src/Containers/Reports/Edit.js